"use client";
import Select, { IndicatorSeparatorProps } from "react-select";
import { customStyles } from "./customStyles";

const indicatorSeparatorStyle = {
  backgroundColor: "transparent",
};

const IndicatorSeparator = ({
  innerProps,
}: IndicatorSeparatorProps<[], true>) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

const Dropdown = ({
  customClassName = "",
  onChange,
  value,
  dropdown_data,
  showError,
  errorMessage,
  ...rest
}: any) => {
  return (
    <div className={"bg-black " + customClassName}>
      <Select
        options={dropdown_data}
        styles={customStyles}
        components={{ IndicatorSeparator }}
        value={dropdown_data.find((c: any) => c.value === value)}
        onChange={(val: { value: string }) => onChange(val.value)}
        {...rest}
      />
      {showError && errorMessage ? (
        <div className={`text-error text-xs mt-1`}>{errorMessage}</div>
      ) : null}
    </div>
  );
};

export default Dropdown;
